<template>
	<!-- 统计分析 监督检查统计 -->
	<section>
		<!--列表-->
		<el-table :data="companylist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			
       		<el-table-column prop="MpCn" label="所属城市" align="center" min-width="100">
			</el-table-column>

      		<el-table-column prop="ZGZcount" label="未整改企业数"  align="center" min-width="100">
		 	</el-table-column>

			<el-table-column prop="CXZGZcount" label="重新整改企业数" align="center"  min-width="100">
			</el-table-column>

			<el-table-column prop="FCZcount" label="未复查企业数" align="center"  min-width="100">
			</el-table-column>
     
			<el-table-column prop="ZGWCcount" label="已整改企业数" align="center"  min-width="100">
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

	</section>
</template>

<script>
	import {gjcheckSumPage} from '../../api/api';

	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id

				companylist: [],
				total: 0,
				page: 1,
				listLoading: false,
				
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.page = val;
				this.getGjCheckSumListPage();
			},
			//获取列表
			getGjCheckSumListPage() {
				let para = {
					page: this.page,
					pageSize:20,
					objectId:this.objectId,
				};

				this.listLoading = true;

				gjcheckSumPage(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.companylist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId
			this.getGjCheckSumListPage();
		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// checkForm.vue?c49ccf00